
import { useEffect, useState } from 'react'
import ButtonGoRedeem from 'components/button-go'
import { BackRedeem, TextSub } from 'theme/theme'
import textServices from 'services/text-services'
import ErrorView from 'components/error-view'

const Redeem = () => {
  const [isFocused, setIsFocused] = useState(false)
  const [redeemError, setRedeemError] = useState<number | null>(null)

  useEffect(() => {
    const event = new CustomEvent('background-color', {
      detail: {
        shouldUseWhiteBg: redeemError !== null
      }
    })
    window.dispatchEvent(event)
  }, [redeemError])

  if (redeemError) return <ErrorView code={redeemError} buttonMenu={() => setRedeemError(null)} onRetry={() => setRedeemError(null)} />

  return (
    <section className="flex-1 py-0 flex flex-col items-center din large-screen-paddingb" style={{ maxHeight: 1080 }}>
      <BackRedeem className="flex flex-1 w-full mt-24 bg-no-repeat bg-cover sm:bg-contain bg-center items-center" style={{ backgroundImage: `url(${`${AZURE_BASE_URL}/fondo-secundario.svg`})` }}>
        {
          textServices.findByText('redeem/title') !== 'redeem/title' ?
            <TextSub className="font-black uppercase text-center text-xml17 leading-none sm:max-w-sm  px-7 mt-6">
              {textServices.findByText('redeem/title')}
            </TextSub>
            :
            <img src={`${AZURE_BASE_URL}/redeem-welcome.svg`} className="mx-10 w-full mt-6 max-w-md" />
        }

      </BackRedeem>
      <div className={`flex flex-col flex-2 sm:mt-1 w-full justify-center px-7 sm:max-w-sm sm:items-center`}>
        <div className="flex flex-col mt-6 mb-6 gap-4" >
          <p className="text-center uppercase">
            {textServices.findByText('redeem/description', <>Ingresa el código que se encuentra dentro de <br /> los 12 pack para sumar puntos en el ranking</>)}
          </p>
        </div>
      </div>
      <ButtonGoRedeem setIsFocused={setIsFocused} isFocused={isFocused} redeemError={redeemError} setRedeemError={setRedeemError} />
    </section>
  )
}

export default Redeem
